module.exports = __webpack_public_path__ + "media/images/placeholders/article-placeholder-0e029b60f469801426ab6644bf9d94b1.jpg";